import { lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { Bounce, ToastContainer } from "react-toastify";
import "./App.css";
import { Box } from "@mui/material";
import Spinner from "./components/Spinner.jsx";
import NetworkMonitor from "./components/NetworkMonitor.jsx";
import OfflinePopup from "./pages/OfflinePopup.jsx";

const MainLayout = lazy(() => import("./components/MainLayout"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const FeedBack = lazy(() => import("./pages/FeedBack.jsx"));
const Login = lazy(() => import("./pages/Login"));
const NotFound = lazy(() => import("./pages/NotFound.jsx"));
const ProfileSettings = lazy(() => import("./pages/ProfileSettings.jsx"));
const Reports = lazy(() => import("./pages/Reports/index.jsx"));
const TestNewScreen = lazy(() => import("./pages/TestNewScreen/index.jsx"));
const FirstValuation = lazy(() => import("./pages/Valuation/index.jsx"));
const Evaluation = lazy(() => import("./pages/Valuation/Evaluation.jsx"));

const RouteLoader = () => (
	<div className="grid min-h-screen place-items-center bg-[var(--dashboardBg)] text-[var(--dashboardTextPrimary)]">
		<Box className="sublayout !bg-[var(--dashboardBg)] !p-4 text-center flex flex-col justify-center gap-2">
			<Spinner loadingText={"Preparing ..."} />
		</Box>
	</div>
);

function App() {
	return (
		<>
		<NetworkMonitor />
      	<OfflinePopup />
			<Router>
				<Suspense fallback={<RouteLoader />}>
					<Routes>
						<Route path="/" element={<TestNewScreen />} />
						<Route path="/login" element={<Login />} />
						<Route path="/terms-of-use" element={<NotFound />} />
						<Route path="/cookies-preferences" element={<NotFound />} />
						<Route path="/privacy" element={<NotFound />} />
						<Route path="*" element={<NotFound />} />
						{/* <Route
							path="/qp/:examinationCode/:questionPaperCode"
							element={<QuestionPaperPdf />}
						/> */}
						<Route element={<MainLayout />}>
							<Route path="/Dashboard" element={<Dashboard />} />
							<Route path="/FirstValuation" element={<FirstValuation />} />
							<Route path="/Valuation" element={<Evaluation />} />
							<Route path="/Reports" element={<Reports />} />
							<Route path="/profile-settings" element={<ProfileSettings />} />
							<Route path="/FeedBack" element={<FeedBack />} />
						</Route>
					</Routes>
				</Suspense>
			</Router>
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick={false}
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
				transition={Bounce}
			/>
		</>
	);
}

export default App;
